import React from 'react';
import { useParams } from 'react-router-dom';

const labels = {
  home: 'Home',
  about: 'About',
  products: 'Products',
  contact: 'Contact',
  rfq: 'RFQ',
};

export default function PagePlaceholder() {
  const { pageName } = useParams();
  const title = labels[pageName] || pageName;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-gray-900">Pages · {title}</h1>
      <p className="mt-2 text-sm text-gray-600">
        Page editor UI is not implemented yet. This route is a placeholder so sidebar navigation works.
      </p>
    </div>
  );
}
